<template>
  <div>
    <country :country="country" :survey="survey" :getSurvey="getSurvey" />
  </div>
</template>

<script>
import Country from './Country'

export default {
  props: {
    country: {
      required: true,
    },
    survey: {
      required: true,
    },
    getSurvey: {
      required: true,
    },
  },
  components: {
    Country,
  },
}
</script>

<style></style>
